import {
  Box,
  Flex,
  FormLabel,
  HStack,
  Spinner,
  Stack,
  useDisclosure,
  useToast,
  Text,
  AlertDescription,
  Alert,
  CloseButton,
  Icon,
  Link as ChakraLink,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useHistory, Link as ReactRouterLink } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component';
import { useForm } from 'react-hook-form';
import { FiMessageCircle } from 'react-icons/fi';
import { Button, Footer, Heading, Input, Select, Textarea } from '~/components';
import { SearchSeriesNumber } from '../TechnicalSupport/SearchSeriesNumber';
import { Pagination, SelectItem, State } from '~/types';
import { validateNotificationEmail } from '~/utils/emailRegex';
import { MultiSelectStrings } from '~/utils/multiSelectStrings';
import { SeriesNumber } from '~/types/sinisters';
import { getCompanyAddressById } from '~/services';
import { useAuth } from '~/hooks';
import apiAssist from '~/utils/apiAssist';
import api from '~/utils/api';
import { ConfirmationDialog } from '~/components/ConfirmationDialog';
import { ROUTER_PATHS } from '~/constants';

type NewOccurrenceFormData = {
  nu_serie: string;
  nome_unidade: string;
  descricao_produto: string;
  cnpj_unidade: string;
  descricao_problema: string;
  empresa_endereco: string;
  empresa_numero: string;
  empresa_bairro: string;
  empresa_cidade: string;
  empresa_uf: string;
  empresa_cep: string;
  empresa_complemento: string;
  contato_nome: string;
  contato_email: string;
  contato_id: string;
  celular_ddd: string;
  celular_numero: string;
  telefone_ddd: string;
  telefone_numero: string;
  horario_visita: number;
  informacoes_adicionais: string;
};

export const NewOccurrence: React.VFC = () => {
  const history = useHistory();
  const toast = useToast();
  const { user } = useAuth();
  const {
    isOpen: isOpenModal,
    onOpen: onOpenModal,
    onClose: onCloseModal,
  } = useDisclosure();

  const {
    isOpen: isVisible,
    onClose: onCloseAlert,
    onOpen,
  } = useDisclosure({ defaultIsOpen: true });

  const [isFetching, setIsFetching] = useState(false);
  const [equipmentIsOk, setEquipmentIsOk] = useState(false);
  const [companyId, setCompanyId] = useState<string>('');

  const [selectedTechnicalVisitSchedules, setSelectedTechnicalVisitSchedules] =
    useState<SelectItem[]>([]);

  const [nu_serie, setnu_serie] = useState<string>('');
  const [nome_unidade, setnome_unidade] = useState<string>('');
  const [descricao_produto, setdescricao_produto] = useState<string>('');
  const [modelo_produto, setModeloProduto] = useState<string>('');
  const [tipo_produto, setTipoProduto] = useState<string>('');
  const [cnpj_unidade, setcnpj_unidade] = useState<string>('');
  const [descricao_problema, setdescricao_problema] = useState<string>('');
  const [empresa_endereco, setempresa_endereco] = useState<string>('');
  const [empresa_numero, setempresa_numero] = useState<string>('');
  const [codigo_cliente, setcodigo_cliente] = useState<string>('');
  const [empresa_bairro, setempresa_bairro] = useState<string>('');
  const [empresa_cidade, setempresa_cidade] = useState<string>('');
  const [empresa_uf, setempresa_uf] = useState<string>('');
  const [empresa_cep, setempresa_cep] = useState<string>('');
  const [empresa_complemento, setempresa_complemento] = useState<string>('');
  const [contato_nome, setcontato_nome] = useState<string>('');
  const [contato_email, setcontato_email] = useState<string>('');
  const [contato_id, setcontato_id] = useState<string>('');
  const [celular_ddd, setcelular_ddd] = useState<string>('');
  const [celular_numero, setcelular_numero] = useState<string>('');
  const [telefone_ddd, settelefone_ddd] = useState<string>('');
  const [telefone_numero, settelefone_numero] = useState<string>('');
  const [informacoes_adicionais, setinformacoes_adicionais] =
    useState<string>('');
  const [estados, setEstados] = useState<SelectItem[]>([]);

  const {
    register,
    handleSubmit,
    setValue,
    control,
    setError,
    formState: { errors },
    clearErrors,
  } = useForm<NewOccurrenceFormData>();

  useEffect(() => {
    setcontato_nome(user.name);
    setcontato_email(user.email);
    setcontato_id(user.id.toString());
  }, [user]);

  useEffect(() => {
    if (equipmentIsOk) {
      setIsFetching(true);
      getCompanyAddressById(companyId)
        .then(response => {
          setempresa_endereco(response.nm_endereco || '');
          setempresa_numero(response.nu_endereco || '');
          setempresa_cidade(response.nm_cidade || '');
          setempresa_uf(response.estado.sg_estado || '');
          setempresa_complemento(response.ds_complementoendereco || '');
          setcodigo_cliente(response.cd_usuariosap || '');
        })
        .catch(() => {
          toast({
            title: 'Erro',
            description: 'Erro ao obter endereço da empresa',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        })
        .finally(() => {
          setIsFetching(false);
        });
    } else {
      clearAddressValues();
    }
  }, [equipmentIsOk]);

  useEffect(() => {
    api
      .get<Pagination<State>>('/estados', {
        params: {
          page: 1,
          size: 30,
        },
      })
      .then(response => {
        const selectableItems: SelectItem[] = response.data.results?.map(
          state => ({
            label: state.nm_estado,
            value: state.sg_estado,
          }),
        );
        setEstados(selectableItems);
      });
  }, []);

  const handleTechnicalVisitScheduleChanges = (changes: SelectItem[]) => {
    setSelectedTechnicalVisitSchedules(changes);
  };

  const handleSeriesNumberSelected = (item: SeriesNumber | undefined) => {
    setnome_unidade(item?.empresa_razao_social || '');
    setdescricao_produto(item?.equipamento_descricao || '');
    setModeloProduto(item?.equipamento_modelo || '');
    setTipoProduto(item?.equipamento_tipo || '');
    setcnpj_unidade(item?.cnpj || '');
    setnu_serie(item?.numero_serie.toString() || '');
    setCompanyId(item?.id_empresa.toString() || '');
    setEquipmentIsOk(!!item);
  };

  const clearAddressValues = () => {
    setempresa_endereco('');
    setempresa_numero('');
    setempresa_bairro('');
    setempresa_cidade('');
    setempresa_uf('');
    setempresa_cep('');
    setempresa_complemento('');
    clearErrors();
  };

  const validate = () => {
    let isValid = true;

    !nu_serie.trim() &&
      setError('nu_serie', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    !nome_unidade.trim() &&
      setError('nome_unidade', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    !descricao_produto.trim() &&
      setError('descricao_produto', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    !cnpj_unidade.trim() &&
      setError('cnpj_unidade', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    !descricao_problema.trim() &&
      setError('descricao_problema', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    !empresa_endereco.trim() &&
      setError('empresa_endereco', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    !empresa_numero.trim() &&
      setError('empresa_numero', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    !empresa_bairro.trim() &&
      setError('empresa_bairro', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    !empresa_cidade.trim() &&
      setError('empresa_cidade', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    !empresa_uf.trim() &&
      setError('empresa_uf', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    !empresa_cep.trim() &&
      setError('empresa_cep', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    !contato_nome.trim() &&
      setError('contato_nome', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    !contato_email.trim() &&
      setError('contato_email', {
        type: 'required',
        message: 'Campo obrigatório',
      });

    !(informacoes_adicionais.trim().length <= 300) &&
      setError('informacoes_adicionais', {
        type: 'maxLength',
        message: 'Campo deve ter no máximo 300 caracteres',
      });

    !(empresa_complemento.trim().length <= 255) &&
      setError('empresa_complemento', {
        type: 'maxLength',
        message: 'Campo deve ter no máximo 300 caracteres',
      });

    !(descricao_problema.trim().length <= 300) &&
      setError('descricao_problema', {
        type: 'maxLength',
        message: 'Campo deve ter no máximo 300 caracteres',
      });

    !(empresa_endereco.trim().length <= 255) &&
      setError('empresa_endereco', {
        type: 'maxLength',
        message: 'Campo deve ter no máximo 255 caracteres',
      });

    !(empresa_numero.trim().length <= 10) &&
      setError('empresa_numero', {
        type: 'maxLength',
        message: 'Campo deve ter no máximo 10 caracteres',
      });

    !(empresa_bairro.trim().length <= 100) &&
      setError('empresa_bairro', {
        type: 'maxLength',
        message: 'Campo deve ter no máximo 10 caracteres',
      });

    !(empresa_cidade.trim().length <= 100) &&
      setError('empresa_cidade', {
        type: 'maxLength',
        message: 'Campo deve ter no máximo 100 caracteres',
      });

    !(contato_nome.trim().length <= 100) &&
      setError('contato_nome', {
        type: 'maxLength',
        message: 'Campo deve ter no máximo 100 caracteres',
      });

    !(contato_email.trim().length <= 100) &&
      setError('contato_email', {
        type: 'maxLength',
        message: 'Campo deve ter no máximo 100 caracteres',
      });

    !celular_ddd.trim() &&
      setError('celular_ddd', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    celular_ddd.replace(/[()]/g, '').trim().length &&
      !(celular_ddd.replace(/[()]/g, '').trim().length === 2) &&
      setError('celular_ddd', {
        type: 'minLength',
        message: 'Campo deve ter 2 caracteres',
      });

    !telefone_ddd.trim() &&
      setError('telefone_ddd', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    telefone_ddd.replace(/[()]/g, '').trim().length &&
      !(telefone_ddd.replace(/[()]/g, '').trim().length === 2) &&
      setError('telefone_ddd', {
        type: 'minLength',
        message: 'Campo deve ter 2 caracteres',
      });

    !celular_numero.trim() &&
      setError('celular_numero', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    celular_numero.replace(/-/g, '').trim().length &&
      !(celular_numero.replace(/-/g, '').trim().length === 9) &&
      setError('celular_numero', {
        type: 'minLength',
        message: 'Campo deve ter 9 caracteres',
      });

    !telefone_numero.trim() &&
      setError('telefone_numero', {
        type: 'required',
        message: 'Campo obrigatório',
      });
    telefone_numero.replace(/-/g, '').trim().length &&
      !(telefone_numero.replace(/-/g, '').trim().length === 8) &&
      setError('telefone_numero', {
        type: 'minLength',
        message: 'Campo deve ter 8 caracteres',
      });

    empresa_cep.replace(/-/g, '').trim().length &&
      !(empresa_cep.replace(/-/g, '').trim().length === 8) &&
      setError('empresa_cep', {
        type: 'minLength',
        message: 'Campo deve ter 8 caracteres',
      });

    if (
      contato_email.trim() &&
      !validateNotificationEmail(contato_email.trim())
    ) {
      setError(`contato_email`, {
        type: 'pattern',
        message: 'E-mail inválido',
      });
    }

    if (!selectedTechnicalVisitSchedules.length) {
      toast({
        title: 'Selecionar ao menos um horário de visita é obrigatório',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
      isValid = false;
    }
    const { _formState } = control;
    return _formState.isValid && isValid;
  };

  const handleCreate = () => {
    if (!validate()) return;
    const formdata = {
      nu_serie,
      nome_unidade,
      descricao_produto,
      cnpj_unidade: cnpj_unidade.replace(/[./-]/g, ''),
      descricao_problema,
      codigo_cliente,
      empresa_endereco,
      empresa_numero,
      empresa_bairro,
      empresa_cidade,
      empresa_uf,
      empresa_cep: empresa_cep.replace(/-/g, ''),
      empresa_complemento,
      contato_nome,
      contato_email,
      contato_id,
      celular_ddd: celular_ddd.replace(/[()]/g, ''),
      celular_numero: celular_numero.replace(/-/g, ''),
      telefone_ddd: telefone_ddd.replace(/[()]/g, ''),
      telefone_numero: telefone_numero.replace(/-/g, ''),
      horario_visita:
        selectedTechnicalVisitSchedules.length === 1
          ? selectedTechnicalVisitSchedules[0].value
          : 3,
      informacoes_adicionais,
    };
    setIsFetching(true);
    apiAssist
      .post('/abertura/', formdata)
      .then(response => {
        onOpenModal();
      })
      .catch(err => {
        toast({
          title: 'Falha na abertura do chamado',
          description: 'Contate o administrador',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .finally(() => {
        setIsFetching(false);
      });
  };

  const technicalVisitSchedules = [
    { value: '1', label: 'Manhã: 08:00 às 12:00' },
    { value: '2', label: 'Tarde: 13:00 às 18:00' },
  ];

  return (
    <Flex flexDir="column">
      <Box px="8" py="4" pb="8rem" maxW="70%">
        <Heading hasBackButton>Abrir chamado</Heading>
        <Stack py="8" px="4" gridGap={6}>
          <Stack gridGap={4}>
            <Heading>Equipamento</Heading>
            <Flex gridGap={6}>
              <Flex w="40%">
                <SearchSeriesNumber
                  onChangeObj={item => {
                    handleSeriesNumberSelected(item);
                  }}
                  label="Nº de série"
                  placeholder="Nº de série"
                  width="100%"
                  isRequired
                  labelFontSize="14px"
                />
              </Flex>
              <Input
                name="modelo_produto"
                value={modelo_produto}
                type="text"
                fontSize="15px"
                label="Modelo"
                height="38px"
                isDisabled
              />
              <Input
                name="tipo_produto"
                value={tipo_produto}
                type="text"
                fontSize="15px"
                label="Tipo"
                height="38px"
                isDisabled
              />
            </Flex>
            <Flex gridGap={6}>
              <Input
                name="descricao_produto"
                value={descricao_produto}
                type="text"
                fontSize="15px"
                label="Descrição do produto"
                height="38px"
                isDisabled
              />
            </Flex>
            <Flex w="100%" gridGap={6}>
              <Input
                isRequired
                value={nome_unidade}
                name="nome_unidade"
                isDisabled
                type="text"
                fontSize="15px"
                label="Nome da unidade"
                height="38px"
              />
              <Flex w="40%">
                <Input
                  isRequired
                  value={cnpj_unidade}
                  name="cnpj_unidade"
                  isDisabled
                  type="text"
                  fontSize="15px"
                  label="CNPJ da unidade"
                  height="38px"
                  isInputMask
                  mask="99.999.999/9999-99"
                />
              </Flex>
            </Flex>
          </Stack>
          <Stack gridGap={4}>
            <Heading>Descrição do problema</Heading>
            <Textarea
              isRequired
              label="Descreva o problema"
              name="descricao_problema"
              onChange={e => {
                setdescricao_problema(e.target.value);
                clearErrors('descricao_problema');
              }}
              value={descricao_problema}
              error={errors.descricao_problema}
            />
          </Stack>
          <Stack gridGap={4}>
            <Heading>Endereço</Heading>
            <HStack gridGap={6} alignItems="baseline">
              <Input
                isRequired
                name="empresa_endereco"
                value={empresa_endereco}
                onChange={e => {
                  setempresa_endereco(e.target.value);
                  clearErrors('empresa_endereco');
                }}
                type="text"
                fontSize="15px"
                label="Endereço"
                height="38px"
                error={errors.empresa_endereco}
              />
              <Input
                isRequired
                name="empresa_numero"
                value={empresa_numero}
                onChange={e => {
                  setempresa_numero(e.target.value);
                  clearErrors('empresa_numero');
                }}
                type="text"
                fontSize="15px"
                label="Número"
                height="38px"
                error={errors.empresa_numero}
              />
              <Input
                isRequired
                name="empresa_bairro"
                value={empresa_bairro}
                onChange={e => {
                  setempresa_bairro(e.target.value);
                  clearErrors('empresa_bairro');
                }}
                type="text"
                fontSize="15px"
                label="Bairro"
                height="38px"
                error={errors.empresa_bairro}
              />
            </HStack>
            <HStack gridGap={6} alignItems="baseline">
              <Input
                isRequired
                name="empresa_cidade"
                value={empresa_cidade}
                onChange={e => {
                  setempresa_cidade(e.target.value);
                  clearErrors('empresa_cidade');
                }}
                type="text"
                fontSize="15px"
                label="Cidade"
                height="38px"
                error={errors.empresa_cidade}
              />
              <Select
                name="estado"
                value={empresa_uf}
                onChange={e => {
                  setempresa_uf(e.target.value);
                  clearErrors('empresa_uf');
                }}
                fontSize="15px"
                label="Estado"
                error={errors?.empresa_uf}
                isDisabled={isFetching}
              >
                <option value="">Selecione...</option>
                {estados?.map(tipo => (
                  <option key={tipo.value} value={tipo.value}>
                    {tipo.label}
                  </option>
                ))}
              </Select>
              <Input
                isRequired
                name="empresa_cep"
                value={empresa_cep}
                onChange={e => {
                  setempresa_cep(e.target.value);
                  clearErrors('empresa_cep');
                }}
                type="text"
                fontSize="15px"
                label="CEP"
                height="38px"
                error={errors.empresa_cep}
                isInputMask
                mask="99999-999"
              />
            </HStack>
            <Input
              name="empresa_complemento"
              value={empresa_complemento}
              onChange={e => {
                setempresa_complemento(e.target.value);
                clearErrors('empresa_complemento');
              }}
              type="text"
              fontSize="15px"
              label="Complemento"
              height="38px"
              error={errors.empresa_complemento}
            />
          </Stack>
          <Stack gridGap={4}>
            <Heading>Contato</Heading>
            <HStack gridGap={6} alignItems="baseline" w="100%">
              <Input
                isRequired
                name="contato_nome"
                value={contato_nome}
                onChange={e => {
                  setcontato_nome(e.target.value);
                  clearErrors('contato_nome');
                }}
                type="text"
                fontSize="15px"
                label="Nome Completo"
                height="38px"
                error={errors.contato_nome}
              />
              <Flex w="70%">
                <Input
                  isRequired
                  name="contato_email"
                  value={contato_email}
                  onChange={e => {
                    setcontato_email(e.target.value);
                    clearErrors('contato_email');
                  }}
                  type="email"
                  fontSize="15px"
                  label="E-mail"
                  height="38px"
                  error={errors.contato_email}
                />
              </Flex>
            </HStack>
            <HStack gridGap={6} alignItems="baseline">
              <Flex gridGap={2}>
                <Flex w="30%" minW={{ sm: '60px' }}>
                  <Input
                    isRequired
                    name="celular_ddd"
                    value={celular_ddd}
                    onChange={e => {
                      setcelular_ddd(e.target.value);
                      clearErrors('celular_ddd');
                    }}
                    placeholder="(99)"
                    type="text"
                    fontSize="15px"
                    label="DDD"
                    height="38px"
                    isInputMask
                    mask="(99)"
                    error={errors.celular_ddd}
                  />
                </Flex>
                <Input
                  isRequired
                  name="celular_numero"
                  value={celular_numero}
                  onChange={e => {
                    setcelular_numero(e.target.value);
                    clearErrors('celular_numero');
                  }}
                  type="text"
                  fontSize="15px"
                  label="Celular"
                  height="38px"
                  placeholder="99999-9999"
                  isInputMask
                  mask="99999-9999"
                  error={errors.celular_numero}
                />
              </Flex>
              <Flex gridGap={2}>
                <Flex w="30%" minW={{ sm: '60px' }}>
                  <Input
                    isRequired
                    name="telefone_ddd"
                    value={telefone_ddd}
                    onChange={e => {
                      settelefone_ddd(e.target.value);
                      clearErrors('telefone_ddd');
                    }}
                    type="text"
                    fontSize="15px"
                    label="DDD"
                    height="38px"
                    placeholder="(99)"
                    isInputMask
                    mask="(99)"
                    error={errors.telefone_ddd}
                  />
                </Flex>
                <Input
                  isRequired
                  name="telefone_numero"
                  value={telefone_numero}
                  onChange={e => {
                    settelefone_numero(e.target.value);
                    clearErrors('telefone_numero');
                  }}
                  type="text"
                  fontSize="15px"
                  label="Telefone"
                  height="38px"
                  placeholder="9999-9999"
                  isInputMask
                  mask="9999-9999"
                  error={errors.telefone_numero}
                />
              </Flex>
            </HStack>
          </Stack>
          <Stack gridGap={4}>
            <Heading>Informações para atendimento</Heading>
            <Stack w="30%">
              <FormLabel fontSize="14px" m={0}>
                Horário de expediente para visita técnica{' '}
                <span style={{ color: 'red' }}>*</span>
              </FormLabel>
              <MultiSelect
                value={selectedTechnicalVisitSchedules}
                options={technicalVisitSchedules}
                onChange={(changes: SelectItem[]) =>
                  handleTechnicalVisitScheduleChanges(changes)
                }
                disabled={isFetching}
                labelledBy="Selecione"
                overrideStrings={MultiSelectStrings}
              />
            </Stack>
            <Textarea
              value={informacoes_adicionais}
              onChange={e => {
                setinformacoes_adicionais(e.target.value);
                clearErrors('informacoes_adicionais');
              }}
              label="Informações adicionais"
              name="problemDescription"
              error={errors.informacoes_adicionais}
            />
          </Stack>
        </Stack>
      </Box>
      <Footer>
        <HStack>
          <Button
            variant="secondary"
            onClick={history.goBack}
            isDisabled={isFetching}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            isDisabled={isFetching || !equipmentIsOk}
            onClick={handleCreate}
          >
            Abrir chamado
            {isFetching && <Spinner style={{ marginLeft: '10px' }} />}
          </Button>
        </HStack>
      </Footer>
      <ConfirmationDialog
        confirmar={() => {
          onCloseModal();
          history.goBack();
        }}
        onClose={() => {
          onCloseModal();
          history.goBack();
        }}
        isOpen={isOpenModal}
        titulo="Chamado em espera"
        colorfulBar={false}
        hasCloseButton={false}
        size="sm"
      >
        <Text>
          Sua solicitação será processada e enviaremos a resposta por e-mail.
        </Text>
      </ConfirmationDialog>

      {isVisible && (
        <Alert
          status="success"
          alignItems="flex-start"
          textAlign="center"
          position="absolute"
          top="40"
          right="10"
          w="330px"
          bg="#805ad5"
          color="white"
          borderRadius={4}
        >
          <Icon as={FiMessageCircle} w={5} h={6} />
          <Stack textAlign="left" px={2}>
            <AlertDescription>
              Gostaria de tentar nosso Suporte Técnico automatizado?
            </AlertDescription>
            <ChakraLink
              as={ReactRouterLink}
              to={ROUTER_PATHS.PORTAL.TECHNICAL_SUPPORT}
              textDecoration="underline"
            >
              Ir para suporte automatizado
            </ChakraLink>
          </Stack>
          <CloseButton
            alignSelf="flex-start"
            position="relative"
            right={-1}
            top={-1}
            onClick={onCloseAlert}
          />
        </Alert>
      )}
    </Flex>
  );
};
